import { Activity } from "./activity";
import { SubActivity } from "./sub-activity";

export class MainActivity extends Activity{
	mainActivity:string = "";
	subActivities:SubActivity[] = [];

	public constructor(data:any){
		super(data);
		this.mainActivity = data.mainActivity;
		this.subActivities = (data.subActivities || []).map((m:any)=>new SubActivity(m));
	}
}